<template>
	<div class="">

		<Header></Header>
		<div class="Teachermore">
			<ul>
				<li v-for="(item,index) in teacherData" :key="index" @click="openteacher(item.id)">
					<div class="tmbg">
						<img :src="item.cover" :alt="item.name" />
					</div>
					<div class="tmtitle">
							<p>{{item.name}}</p>
							<p>{{item.title}}</p>
					</div>
					<div class="line"></div>
					<div class="tmcount">
						<p>{{item.description.substring(0,25)}}...</p>
					</div>
				</li>
			</ul>
		</div>
		<Fotter></Fotter>
	</div>
</template>
<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import __Config from '../api/config';
	export default {
		name: 'Teachermore',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
                 teacherData:[],
			}
		},
		methods: {
		//老师列表
			getwebTeachers(){
				 this.$toast.loading({
					duration: 0,  
					mask: true,
					message: '加载中...'
				});
                  var that = this;
			      this.$axios.get(__Config.api.getwebTeacher,{
					params: {
						pageNo:1,
						pageSize:20
					}
				})
				.then(function (res) {
					 that.$toast.clear();
					that.teacherData = res.data.data;
				
				})
				.catch(function (err) {
					 that.$toast.clear();
					console.log(err);
				});
			},
			//老师详情
			openteacher(id){
                 this.$router.push({  
					name:"TeacherDetail", 
					params: {   
						id: id,   
					}   
				})    
			},
		},
		created(){
           this.getwebTeachers();
		}
	}
</script>

<style scoped>
	/*li列表样式可共用*/
	.Teachermore {
		width: 98%;
		margin: 20px auto;
	}

	.Teachermore ul li {
	    display: inline-block;
    width: 48%;
    margin: 7px 0.1875rem;
    -webkit-box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.1);
    box-shadow: 0px 2px 2px 2px #6666665c;
    border-radius: 7px;
    background: #fff;

	}

	/*li列表样式end*/
	.tmbg {
		width: 100%;
		height: 200px;
	}

	.tmbg img {
		width: 100%;
		height: 100%;
	}

	.tmtitle p {
		margin: 13px;
	}

	.tmtitle p:nth-child(1) {
		font-size: 14px;
		color: #333;
		font-weight: bold;
	}

	.tmtitle p:nth-child(2) {
		font-size: 14px;
		color: #333;

	}

	.line {
		width: 90%;
		height: 1px;
		background: #ccc;
		margin: 0 auto;
	}

	.tmcount {
		height: 70px;
		overflow: hidden;
		margin-top: -10px;

	}

	.tmcount p {
		font-size: 13px;
		color: #666;
		margin: 13px;
	}







</style>



// WEBPACK FOOTER //
// src/components/Teachermore.vue